import Vue from 'vue'
import Router from 'vue-router'


import Login from '@/components/account/Login'
import Register from '@/components/account/Register'
import Confirm from '@/components/account/Confirm'
import ForgotPassword from '@/components/account/ForgotPassword'
import ChangePassword from '@/components/account/ChangePassword'

import UserProfile from '@/components/profiles/UserProfile'
import Wallet from '@/components/profiles/Wallet'


import Tickets from '@/components/crm/Tickets'
import Ticket from '@/components/crm/Ticket'

import Invoice from '@/components/financial/Invoice'
import Invoices from '@/components/financial/Invoices'

import Dashboard from '@/components/dashboards/Dashboard'
import Services from '@/components/dashboards/Services'
import Request from '@/components/dashboards/Request'

import Announcements from '@/components/cms/Announcements'
import Announcement from '@/components/cms/Announcement'

import Error from '@/components/pages/Error'

import Calendar from '@/components/calendar/Calendar'
import Statistician from '@/components/tools/Statistician'

export default [

    {
        path: '/account/login',
        name: 'UserLogin',
        component: Login,
        meta: { access: ["*"], title: 'ورود' },
    },
    {
        path: '/account/register',
        name: 'UserRegister',
        component: Register,
        meta: { access: ["*"], title: 'ثبت نام' },
    },
    {
        path: '/account/:id/userConfirm',
        name: 'UserConfirm',
        component: Confirm,
        meta: { access: ["*"], title: 'تکمیل ثبت نام' },
    },
    {
        path: '/account/forgotPassword',
        name: 'ForgotPassword',
        component: ForgotPassword,
        meta: { access: ["*"], title: 'فراموشی رمز عبور' },
    },
    {
        path: '/account/:id/resetPassword',
        name: 'ResetPassword',
        component: Confirm,
        meta: { access: ["*"], title: 'تغییر رمزعبور' },
    },
    {
        path: '/',
        name: 'Home',
        component: Dashboard,
        meta: { access: ["Client"], title: 'داشبرد' },
    },
    {
        path: '/profile/:id/edit',
        name: 'EditProfile',
        component: UserProfile,
        meta: { access: ["Client"], title: 'ویرایش پروفایل' },
    },
    {
        path: '/account/:id/changePassword',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: { access: ["Client"], title: 'تغییر رمزعبور' },
    },
    {
        path: '/tickets/:type?',
        name: 'Tickets',
        component: Tickets,
        meta: { access: ["Client"], title: 'تیکت ها' },
    },
    {
        path: '/tickets/:ticketId',
        name: 'Ticket',
        component: Ticket,
        meta: { access: ["Client"], title: 'پاسخ به تیکت' },
    },
    {
        path: '/invoices/:invoiceId',
        name: 'Invoice',
        component: Invoice,
        meta: { access: ["Client"], title: 'فاکتور' },
    },
    {
        path: '/invoices',
        name: 'Invoices',
        component: Invoices,
        meta: { access: ["Client"], title: 'فاکتورها' },
    },
    {
        path: '/services/:serviceId',
        name: 'Service',
        component: Services,
        meta: { access: ["Client"], title: 'سرویس' },
    },
    {
        path: '/services',
        name: 'Services',
        component: Services,
        meta: { access: ["Client"], title: 'سرویس ها' },
    },
    {
        path: '/request/:type/:id?',
        name: 'Request',
        component: Request,
        meta: { access: ["Client"], title: 'درخواست ها' },
    },
    {
        path: '/wallet',
        name: 'Wallet',
        component: Wallet,
        meta: { access: ["Client"], title: 'کیف پول' },
    },
    {
        path: '/Announcements/',
        name: 'Announcements',
        component: Announcements,
        meta: { access: ["Client"], title: 'آخرین اخبار' },
    },
    {
        path: '/Announcements/:announcementId',
        name: 'Announcement',
        component: Announcement,
        meta: { access: ["Client"], title: 'اعلامیه' },
    },
    {
        path: '/Statistician/',
        name: 'Statistician',
        component: Statistician,
        meta: { access: ["Client"], title: 'آمار وب سایت' },
    },
    // {
    //     path: '/Announcements/:announcementId',
    //     name: 'Announcement',
    //     component: Announcement,
    //     meta: { access: ["Client"], title: 'اعلامیه' },
    // },
    {
        path: '/Error/:error?',
        name: 'Error',
        component: Error
    },
    { path: "*", component: Error },


    {
        path: '/calendar/calendar',
        name: 'Calendar',
        component: Calendar
    }
];